<footer class="neo-footer">
  <!-- Ambient glow lines -->
  <div class="footer-glow-line"></div>

  <div class="app-container">
    <div class="footer-inner">
      <!-- Brand Column -->
      <div class="footer-brand">
        <a class="f-brand-link" routerLink="/">
          <div class="f-brand-icon">
            <svg
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
              />
            </svg>
          </div>
          <span class="f-brand-text">Fly<span>DnA</span></span>
        </a>
        <p class="f-tagline">
          Next-gen orbital navigation &amp; decentralized communication.
          Redefining the digital frontier since 2026.
        </p>
        <!-- System status indicator -->
        <div class="f-status-bar">
          <span class="f-status-dot"></span>
          <span class="f-status-text">SYSTEM_STATUS: OPERATIONAL</span>
        </div>
      </div>

      <!-- Links Column -->
      <div class="footer-links-col">
        <div class="f-col-label">Orbital Links</div>
        <ul class="f-links">
          <li>
            <a routerLink="/">
              <svg
                width="12"
                height="12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                />
              </svg>
              Lobby
            </a>
          </li>
          <li>
            <a routerLink="/profile">
              <svg
                width="12"
                height="12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                />
              </svg>
              User Profile
            </a>
          </li>
          <li>
            <a routerLink="/finance">
              <svg
                width="12"
                height="12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                />
              </svg>
              Dashboard Terminal
            </a>
          </li>
          <li>
            <a routerLink="/store">
              <svg
                width="12"
                height="12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                />
              </svg>
              Marketplace
            </a>
          </li>
        </ul>
      </div>

      <!-- Network/Social Column -->
      <div class="footer-social-col">
        <div class="f-col-label">Network Uplink</div>
        <div class="f-socials">
          <a href="#" class="f-social-btn" aria-label="Facebook">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </a>
          <a href="#" class="f-social-btn" aria-label="Instagram">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.975.975 1.245 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.332 2.633-1.308 3.608-.975.975-2.242 1.245-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.332-3.608-1.308-.975-.975-1.245-2.242-1.308-3.608C.014 15.667 0 15.259 0 12s.014-3.667.072-4.947c.2-4.353 2.62-6.777 6.975-6.977C8.333.014 8.741 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4.162 4.162 0 110-8.324A4.162 4.162 0 0112 16zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
              />
            </svg>
          </a>
          <a href="#" class="f-social-btn" aria-label="Twitter/X">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              />
            </svg>
          </a>
          <a href="#" class="f-social-btn" aria-label="LinkedIn">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              />
            </svg>
          </a>
        </div>
      </div>

      <!-- Newsletter Column -->
      <div class="footer-newsletter-col">
        <div class="f-col-label">Sub-Frequency</div>
        <p class="f-newsletter-desc">
          Get mission-critical updates. No spam. Just signal.
        </p>
        <form
          [formGroup]="newsletterForm"
          (ngSubmit)="onSubmit()"
          class="f-newsletter-form"
        >
          <div class="f-input-wrap">
            <svg
              class="f-input-icon"
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
            <input
              type="email"
              formControlName="email"
              placeholder="Enter uplink email..."
              class="f-input"
            />
          </div>
          <button type="submit" class="f-submit-btn">
            <svg
              width="14"
              height="14"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
              />
            </svg>
            Uplink
          </button>
        </form>
      </div>
    </div>
  </div>

  <!-- Bottom bar -->
  <div class="footer-bottom">
    <span class="f-copy">© 2026 FlyDnA Inc.</span>
    <div class="f-legal-links">
      <a routerLink="/privacy">Privacy Protocol</a>
      <span class="f-sep">//</span>
      <a routerLink="/terms">Terms of Service</a>
    </div>
  </div>
</footer>
